const allStates = [
	{
		name: 'Iowa',
		country: 'us',
		abbr: 'IA',
		counties: [
			'Adair',
			'Adams',
			'Allamakee',
			'Appanoose',
			'Audubon',
			'Benton',
			'Black Hawk',
			'Boone',
			'Bremer',
			'Buchanan',
			'Buena Vista',
			'Butler',
			'Calhoun',
			'Carroll',
			'Cass',
			'Cedar',
			'Cerro Gordo',
			'Cherokee',
			'Chickasaw',
			'Clarke',
			'Clay',
			'Clayton',
			'Clinton',
			'Crawford',
			'Dallas',
			'Davis',
			'Decatur',
			'Delaware',
			'Des Moines',
			'Dickinson',
			'Dubuque',
			'Emmet',
			'Fayette',
			'Floyd',
			'Franklin',
			'Fremont',
			'Greene',
			'Grundy',
			'Guthrie',
			'Hamilton',
			'Hancock',
			'Hardin',
			'Harrison',
			'Henry',
			'Howard',
			'Humboldt',
			'Ida',
			'Iowa',
			'Jackson',
			'Jasper',
			'Jefferson',
			'Johnson',
			'Jones',
			'Keokuk',
			'Kossuth',
			'Lee',
			'Linn',
			'Louisa',
			'Lucas',
			'Lyon',
			'Madison',
			'Mahaska',
			'Marion',
			'Marshall',
			'Mills',
			'Mitchell',
			'Monona',
			'Monroe',
			'Montgomery',
			'Muscatine',
			"O'Brien",
			'Osceola',
			'Page',
			'Palo Alto',
			'Plymouth',
			'Pocahontas',
			'Polk',
			'Pottawattamie',
			'Poweshiek',
			'Ringgold',
			'Scott',
			'Shelby',
			'Sioux',
			'Story',
			'Tama',
			'Taylor',
			'Union',
			'Van Buren',
			'Wapello',
			'Warren',
			'Washington',
			'Wayne',
			'Webster',
			'Winnebago',
			'Winneshiek',
			'Woodbury',
			'Worth',
			'Wright',
		],
	},
	{
		name: 'Nebraska',
		abbr: 'NE',
		country: 'us',
		counties: [
			'Adams',
			'Antelope',
			'Arthur',
			'Banner',
			'Blaine',
			'Boone',
			'Box Butte',
			'Boyd',
			'Brown',
			'Buffalo',
			'Burt',
			'Butler',
			'Cass',
			'Cedar',
			'Chase',
			'Cherry',
			'Cheyenne',
			'Clay',
			'Colfax',
			'Cuming',
			'Custer',
			'Dakota',
			'Dawes',
			'Dawson',
			'Deuel',
			'Dixon',
			'Dodge',
			'Douglas',
			'Dundy',
			'Fillmore',
			'Franklin',
			'Frontier',
			'Furnas',
			'Gage',
			'Garden',
			'Garfield',
			'Gosper',
			'Grant',
			'Greeley',
			'Hall',
			'Hamilton',
			'Harlan',
			'Hayes',
			'Hitchcock',
			'Holt',
			'Hooker',
			'Howard',
			'Jefferson',
			'Johnson',
			'Kearney',
			'Keith',
			'Keya Paha',
			'Kimball',
			'Knox',
			'Lancaster',
			'Lincoln',
			'Logan',
			'Loup',
			'Madison',
			'McPherson',
			'Merrick',
			'Morrill',
			'Nance',
			'Nemaha',
			'Nuckolls',
			'Otoe',
			'Pawnee',
			'Perkins',
			'Phelps',
			'Pierce',
			'Platte',
			'Polk',
			'Red Willow',
			'Richardson',
			'Rock',
			'Saline',
			'Sarpy',
			'Saunders',
			'Scotts Bluff',
			'Seward',
			'Sheridan',
			'Sherman',
			'Sioux',
			'Stanton',
			'Thayer',
			'Thomas',
			'Thurston',
			'Valley',
			'Washington',
			'Wayne',
			'Webster',
			'Wheeler',
			'York',
		],
	},
	{
		name: 'South Dakota',
		abbr: 'SD',
		country: 'us',
		counties: [
			'Aurora',
			'Beadle',
			'Bennett',
			'Bon Homme',
			'Brookings',
			'Brown',
			'Brule',
			'Buffalo',
			'Butte',
			'Campbell',
			'Charles Mix',
			'Clark',
			'Clay',
			'Codington',
			'Corson',
			'Custer',
			'Davison',
			'Day',
			'Deuel',
			'Dewey',
			'Douglas',
			'Edmunds',
			'Fall River',
			'Faulk',
			'Grant',
			'Gregory',
			'Haakon',
			'Hamlin',
			'Hand',
			'Hanson',
			'Harding',
			'Hughes',
			'Hutchinson',
			'Hyde',
			'Jackson',
			'Jerauld',
			'Jones',
			'Kingsbury',
			'Lake',
			'Lawrence',
			'Lincoln',
			'Lyman',
			'Marshall',
			'McCook',
			'McPherson',
			'Meade',
			'Mellette',
			'Miner',
			'Minnehaha',
			'Moody',
			'Pennington',
			'Perkins',
			'Potter',
			'Roberts',
			'Sanborn',
			'Shannon',
			'Spink',
			'Stanley',
			'Sully',
			'Todd',
			'Tripp',
			'Turner',
			'Union',
			'Walworth',
			'Yankton',
			'Ziebach',
		],
	},
];

const allCensusDivisions = [
	{
		name: 'Saskatchewan',
		country: 'ca',
		abbr: 'SK',
		counties: [
			'Division No. 1',
			'Division No. 2',
			'Division No. 3',
			'Division No. 4',
			'Division No. 5',
			'Division No. 6',
			'Division No. 7',
			'Division No. 8',
			'Division No. 9',
			'Division No. 10',
			'Division No. 11',
			'Division No. 12',
			'Division No. 13',
			'Division No. 14',
			'Division No. 15',
			'Division No. 16',
			'Division No. 17',
			'Division No. 18',
		],
	},

	{
		name: 'Alberta',
		country: 'ca',
		abbr: 'AB',
		counties: [
			'Division No. 1',
			'Division No. 2',
			'Division No. 3',
			'Division No. 4',
			'Division No. 5',
			'Division No. 6',
			'Division No. 7',
			'Division No. 8',
			'Division No. 9',
			'Division No. 10',
			'Division No. 11',
			'Division No. 12',
			'Division No. 13',
			'Division No. 14',
			'Division No. 15',
			'Division No. 16',
			'Division No. 17',
			'Division No. 18',
			'Division No. 19',
		],
	},
];

export { allStates, allCensusDivisions };
